import axios from "axios";

import { toastify } from "../components/common/notification";

import { url } from ".";

import { LogParam } from "../types/logParam";
import { errorMessage } from "../utils/common";
import { logError, logInfo } from "../utils/logger";
import { apiUnauthLogout } from "./common";

// always set function name and message for every executable block
// data is optional
const logParams : LogParam = {
  applicationName : "Orchestrator Client",
  screenModuleName: "client\\src\\controllers\\license.ts",
  functionName: "",
  message: "",
}

export const licenseCheck = () =>
  axios.get(`${url}/license/check`, {}).then((res) => {
    logParams.functionName = "licenseCheck";
    logParams.message = "validating license";
    logInfo(logParams);

    return res.data; 
  }).catch((error) => {
      logParams.functionName = "licenseCheck";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      )

  });

export const licenseApi = (token: string) =>
  axios
    .get(`${url}/license`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => { 
      logParams.functionName = "licenseApi";
      logParams.message = "getting license";
      logInfo(logParams);
    
      return res.data; 
    })
    .catch((error) =>
    {
      logParams.functionName = "licenseApi";
      logParams.message = errorMessage(error);
      logError(logParams);

      if (error.response.status == 401) {
        apiUnauthLogout(error,"organizationTaskListApi")
      }else{
        toastify(
          "failure",
          error.response.data.message.length > 0
            ? error.response.data.message
            : "Something went wrong"
        )}
      }
    );

export const signLicense = ({
  instanceId,
  partnerId,
  publicKey,
}: {
  instanceId: string;
  partnerId: string;
  publicKey: string;
}) =>
  axios
    .post(`${url}/license/create`, { instanceId, partnerId, publicKey })
    .then((res) => {
      logParams.functionName = "signLicense";
      logParams.message = `created license for instance ${instanceId}, partner ${partnerId}`;
      logInfo(logParams);
      
      return res.data; 
    })
    .catch((error) =>
    {
      logParams.functionName = "signLicense";
      logParams.message = errorMessage(error);
      logError(logParams);

      toastify(
        "failure",
        error.response.data.message.length > 0
          ? error.response.data.message
          : "Something went wrong"
      )}
    );
